export default "__VITE_ASSET__HJrMdTBk__"